import { useCallback, useEffect, useState } from "react";
import { fetchTerms } from "services/jornada.service";

export default function Terms() {
	const [data, setData] = useState<any>("");

	const loadTerms = useCallback(async () => {
		const content = await fetchTerms();
		setData(content);
	}, []);

	useEffect(() => {
		loadTerms();
	}, [loadTerms]);

	return (
		<div className="font-normal bg-white rounded-xl border-2 border-blue-dark space-y-5 p-5 flex-1 overflow-y-scroll">
			{!data ? (
				<div>Carregando...</div>
			) : (
				<div dangerouslySetInnerHTML={{ __html: data }} />
			)}
		</div>
	);
}
